import styled from '@emotion/styled';
import { createElement, FC } from 'react';

import DummyContent from '../primitive/DummyContent';

export interface Props {
  className?: string;
}

const DummyVisibilityStatus: FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <Status />
    </div>
  );
};

const Status = styled(DummyContent)({
  wordWrap: 'break-word',
  wordBreak: 'break-word' as any,
});

export default DummyVisibilityStatus;
